import{genAliasCollection as s}from"./utils.js";const t={"desktop-blur-base":"2px"},a=s(t,"desktop-blur-");var o={...t,alias:a};export{a as alias,o as default};
//# sourceMappingURL=blur.js.map
